import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { EpdkErrorSnackBarComponent } from './error-snack-bar.component';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatSnackBarModule,
  ],
  declarations: [EpdkErrorSnackBarComponent]
})
export class EpdkErrorSnackBarModule { }
